import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { TourDispatch, TourState } from './../store/store';

export const useTourSelector: TypedUseSelectorHook<TourState> = useSelector;
export const useTourDispatch: () => TourDispatch = useDispatch;
